import * as React from "react";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import MessageEmptyIncidents from "@tunnel-components/@sharded/message/component";
import * as Lodash from "lodash";
import OngletIncident from "@tunnel-components/@sharded/widgets/onglet-navigation/component";
import * as Paths from "@tunnel-enums/index";
// import * as Enums from '@tunnel-enums/index';
// import * as Utils from '@Cyclope-Utils/index';
import VirtualCameraPagination from "@tunnel-components/@sharded/@widgets/camera-virtualized/component";
import VirtualCameraHeader from "@tunnel-components/@sharded/@widgets/camera-virtualized-header/component";
// import * as  shortid from "shortid";
import * as i18next from "i18next";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    onUpdateCurrentPageNumber,
    itemPerRow,
    currentPageNumbers,
    onClickOngletAction,
    ongletActiveAction,
    loading,
    errorserver,
    onSelectSection,
    segmentation,
    itemsPerPage,
    onChangeItemPerRow,
    openHoverCard,
    onOpenhoverCard,
    onSegmented,
    onClosehoverCard,
    ongletActive,
    onClickOnglet,
    onClickBurger,
    activeBurger,
    onExportCSVCamera,
    rediRectToo,
    cameraListData,
    totalElements,
  } = props;
  /** Configuration dela viriable globale , L'objet window représente une fenêtre contenant un document DOM   */
  const API_URL = "env";

  /**
   * @description : retourne un tableau de type string ( )
   * @const
   * @name onglet
   * @type { any []  }
   */

  const onglet: any[] = [
    {
      title: i18next.t("toutes"),
      action: "",
    },
    {
      title: i18next.t(window[API_URL].TUBE_O1),
      action: "",
    },
    {
      title: i18next.t(window[API_URL].TUBE_O2),
      action: "",
    },
    {
      title: i18next.t(window[API_URL].TUBE_O3),
      action: "",
    },
    {
      title: i18next.t("intervention requise"),
      action: [i18next.t("bouge de camera"), i18next.t("pas de signal")],
    },
    {
      title: i18next.t("cameras actives"),
      action: "",
    },
  ];
  /**
   * @description : retourne un string ( environnement)
   * @function
   * @name breadCrumFunction
   * @return { string  }
   */
  const breadCrumFunction = (): string => {
    let breadCrum: string = "";

    if (ongletActive[0]) {
      breadCrum = i18next.t("toutes");
    }
    if (ongletActive[1]) {
      breadCrum = i18next.t(window[API_URL].TUBE_O1);
    }
    if (ongletActive[2]) {
      breadCrum = i18next.t(window[API_URL].TUBE_O2);
    }
    if (ongletActive[3]) {
      breadCrum = i18next.t(window[API_URL].TUBE_O3);
    }
    if (ongletActive[4]) {
      if (!!ongletActiveAction && ongletActiveAction[0]) {
        breadCrum = `${i18next.t("intervention requise")} > ${i18next.t(
          "bouge de camera"
        )}`;
      } else if (!!ongletActiveAction && ongletActiveAction[1]) {
        breadCrum = `${i18next.t("intervention requise")} > ${i18next.t(
          "pas de signal"
        )}`;
      } else if (
        !!ongletActiveAction &&
        !ongletActiveAction[0] &&
        !ongletActiveAction[1]
      ) {
        breadCrum = i18next.t("intervention requise");
      }
    }
    if (ongletActive[5]) {
      breadCrum = i18next.t("cameras actives");
    }

    return breadCrum;
  };
  /**
   * Triage dans un tableau par ordre
   * @method onSortDynamic
   * @param { any[] }  Elem
   * @return { any []}
   * @infos "https://reactjs.org"
   */
  const onSortDynamic = (Elem: any): any => {
    {
      /** vérification de l'existence de l'élement  */
    }
    if (Lodash.isArray(Elem)) {
      return Elem.sort((a: any, b: any) =>
        a.code.toUpperCase() > b.code.toUpperCase()
          ? 1
          : b.code.toUpperCase() > a.code.toUpperCase()
          ? -1
          : 0
      );
    }
  };
  // const incidentDataAll  = Utils.cloneObjectOrArray(cameraListData)
  /**
   * @description : retourne un tableau de type JSX
   * @const
   * @name incidentDataAll
   * @type { JSX.Element  }
   */
  const incidentDataAll: JSX.Element[] =
    cameraListData &&
    !!cameraListData &&
    onSortDynamic(cameraListData).filter((elem: any) => elem !== null);

  /**
   * @description : retourne un tableau de type JSX
   * @const
   * @name incidentDataTubeNord
   * @type { JSX.Element  }
   */
  const incidentDataTubeNord: JSX.Element[] =
    cameraListData &&
    !!cameraListData &&
    onSortDynamic(cameraListData).filter(
      (elem: any) => elem !== null && elem.section && elem.section.id === 1
    );

  /**
   * @description : retourne un tableau de type JSX
   * @const
   * @name incidentDataTubeSud
   * @type { JSX.Element  }
   */
  const incidentDataTubeSud: JSX.Element[] =
    cameraListData &&
    !!cameraListData &&
    onSortDynamic(cameraListData).filter(
      (elem: any) => elem !== null && elem.section && elem.section.id === 2
    );

  /**
   * @description : retourne un tableau de type JSX
   * @const
   * @name incidentDataTubeLB
   * @type { JSX.Element  }
   */
  const incidentDataTubeLB: JSX.Element[] =
    cameraListData &&
    !!cameraListData &&
    onSortDynamic(cameraListData).filter(
      (elem: any) => elem !== null && elem.section && elem.section.id === 3
    );
  /**
   * @description : retourne un tableau de type JSX
   * @const
   * @name incidentDataIntervention
   * @type { JSX.Element  }
   */
  const incidentDataIntervention: JSX.Element[] =
    cameraListData &&
    onSortDynamic(cameraListData).filter(
      (elem: any) => elem.connected === false
    );

  /**
   * @description : retourne un tableau de type JSX
   * @const
   * @name incidentDataCamerasMove
   * @type { JSX.Element  }
   */
  const incidentDataCamerasMove: JSX.Element[] =
    cameraListData &&
    onSortDynamic(cameraListData).filter(
      (elem: any) => elem.connected && elem.move && !elem.noSignal
    );

  /**
   * @description : retourne un tableau de type JSX
   * @const
   * @name incidentDataCameraNoSignal
   * @type { JSX.Element  }
   */
  const incidentDataCameraNoSignal: JSX.Element[] =
    cameraListData &&
    onSortDynamic(cameraListData).filter(
      (elem: any) => elem !== null && elem.connected && elem.noSignal
    );
  /**
   * @description : retourne un tableau de l'ensemble des incidents par groupe
   * @const
   * @name MapDataIntervention
   * @type { JSX.Element  }
   */
  const MapDataIntervention: any[] = [
    incidentDataCamerasMove,
    incidentDataCameraNoSignal,
  ];

  /**
   * @description : retourne un tableau de type JSX
   * @const
   * @name incidentDataCameraActive
   * @type { JSX.Element  }
   */
  const incidentDataCameraActive: JSX.Element[] =
    cameraListData &&
    onSortDynamic(cameraListData).filter(
      (elem: any) =>
        elem !== null &&
        elem.snapshot !== "" &&
        elem.connected &&
        !elem.move &&
        !elem.noSignal
    );

  /**
   * @description : retourne un tableau de l'ensemble des incidents par groupe
   * @const
   * @name DataMap
   * @type { JSX.Element  }
   */
  const MapData: any[] = [
    incidentDataAll,
    incidentDataTubeNord,
    incidentDataTubeSud,
    incidentDataTubeLB,
    incidentDataIntervention,
    incidentDataCameraActive,
  ];
  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @infos "https://reactjs.org"
   */
  return (
    <LayoutGrid
      loading={loading}
      error={errorserver}
      onChangeItemPerRow={onChangeItemPerRow}
      incidentPerRow={true}
      selectSection={onSelectSection}
      segmentation={segmentation}
      // onOpenInhibitionModal={onOpenInhibitionModal}
      // inhibition={inhibition}
      authorization={true}
      onSegmented={onSegmented}
    >
      <section className="tunnel-site animated fadeIn">
        {Lodash.isEqual(totalElements, 0) &&
          !Lodash.isUndefined(totalElements) && (
            <MessageEmptyIncidents
              message={i18next.t("Il ny a pas de cameras")}
              emptyIncident={false}
            />
          )}
        {!Lodash.isEmpty(cameraListData) && !!cameraListData && (
          <BreadCrumb
            onClosehoverCard={onClosehoverCard}
            iconSupervision={true}
            title={i18next.t("supervision")}
            breadText1={i18next.t("cameras")}
            breadText2={breadCrumFunction()}
            onExportCSVCamera={onExportCSVCamera}
            cameraIsExist={true}
            openHoverCard={openHoverCard}
            onOpenhoverCard={onOpenhoverCard}
            links1={Paths.PathsNamesEnums.CAMERAHOME}
            onSegmented={onSegmented}
          />
        )}
        {!Lodash.isEmpty(cameraListData) && !!cameraListData && (
          <OngletIncident
            onglet={onglet}
            onClickOnglet={onClickOnglet}
            ongletBurger={true}
            onClickOngletAction={onClickOngletAction}
            ongletActiveAction={ongletActiveAction}
            ongletActive={ongletActive}
            onClickBurger={onClickBurger}
            activeBurger={activeBurger}
          />
        )}

        <div className="contentAllSite">
          <div id="columns" className="with-3-columns">
            {totalElements &&
              itemsPerPage &&
              activeBurger[0] &&
              !activeBurger[1] &&
              !!ongletActiveAction &&
              !ongletActiveAction[0] &&
              !ongletActiveAction[1] &&
              MapData.map((elem: any, index: number) => {
                return (
                  !!ongletActive &&
                  ongletActive[index] && (
                    <VirtualCameraPagination
                      key={`virtual${index}`}
                      grid={true}
                      rediRectToo={rediRectToo}
                      cameraListData={elem}
                      itemsPerPage={itemsPerPage}
                      currentPageNumbers={currentPageNumbers}
                      onUpdateCurrentPageNumber={onUpdateCurrentPageNumber}
                      itemPerRow={itemPerRow}
                      totalElements={elem.length}
                    />
                  )
                );
              })}
            {totalElements &&
              itemsPerPage &&
              !!activeBurger &&
              activeBurger[0] &&
              !activeBurger[1] &&
              !!ongletActive &&
              ongletActive[4] &&
              MapDataIntervention.map((elem: any, index: number) => {
                return (
                  !!ongletActiveAction &&
                  ongletActiveAction[index] && (
                    <VirtualCameraPagination
                      grid={true}
                      key={`virtual30${index}`}
                      rediRectToo={rediRectToo}
                      cameraListData={elem}
                      itemsPerPage={itemsPerPage}
                      currentPageNumbers={currentPageNumbers}
                      onUpdateCurrentPageNumber={onUpdateCurrentPageNumber}
                      itemPerRow={itemPerRow}
                      totalElements={elem.length}
                    />
                  )
                );
              })}
            {totalElements &&
              itemsPerPage &&
              !activeBurger[0] &&
              activeBurger[1] && (
                <section className="arrays">
                  <VirtualCameraHeader /> {/** header */}
                  {!!ongletActiveAction &&
                    !ongletActiveAction[0] &&
                    !ongletActiveAction[1] &&
                    MapData.map((elem: any, index: number) => {
                      return (
                        !!ongletActive &&
                        ongletActive[index] && (
                          <VirtualCameraPagination
                            grid={false}
                            key={`Vvirtual${index}`}
                            cameraListData={elem}
                            rediRectToo={rediRectToo}
                            itemsPerPage={itemsPerPage}
                            currentPageNumbers={currentPageNumbers}
                            onUpdateCurrentPageNumber={
                              onUpdateCurrentPageNumber
                            }
                            itemPerRow={1}
                            totalElements={elem.length}
                          />
                        )
                      );
                    })}
                  {!!ongletActive &&
                    ongletActive[4] &&
                    MapDataIntervention.map((elem: any, index: number) => {
                      return (
                        !!ongletActiveAction &&
                        ongletActiveAction[index] && (
                          <VirtualCameraPagination
                            grid={false}
                            key={`WWvirtual${index}`}
                            cameraListData={elem}
                            rediRectToo={rediRectToo}
                            itemsPerPage={itemsPerPage}
                            currentPageNumbers={currentPageNumbers}
                            onUpdateCurrentPageNumber={
                              onUpdateCurrentPageNumber
                            }
                            itemPerRow={1}
                            totalElements={elem.length}
                          />
                        )
                      );
                    })}
                </section>
              )}
          </div>
        </div>
      </section>
    </LayoutGrid>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  cameraListData?: any; // ok
  onSegmented?: any;
  segmentation?: any;
  onSelectSection?: any;
  onClickOnglet?: any; // ok
  onClickBurger?: any;
  activeBurger?: any;
  openHoverCard?: any;
  loading?: any; // ok
  ongletActive?: any; // ok
  inhibition?: any;
  onOpenInhibitionModal?: any;
  onOpenhoverCard?: any;
  data?: any;
  noIncidents?: any;
  btnloading?: any;
  errorserver?: any; // ok
  onExportCSVCamera?: any;
  onClosehoverCard?: any;
  onChangeItemPerRow?: any; // ok
  totalElements?: any; //  ok
  itemsPerPage?: any;
  currentPageNumbers?: any;
  onUpdateCurrentPageNumber?: any;
  itemPerRow?: any;
  onClickOngletAction?: any;
  ongletActiveAction?: boolean[];
  rediRectToo?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/camera/home/component.tsx